"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionConfig = exports.currentSectionName = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const odSurveyHelper = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const widgetsNames_1 = require("./widgetsNames");
const helper_1 = require("../../common/helper");
const helpers_1 = require("evolution-common/lib/utils/helpers");
const customHelpers_1 = require("../../common/customHelpers");
exports.currentSectionName = 'tripsIntro';
const previousSectionName = 'selectPerson';
const nextSectionName = 'visitedPlaces';
// Config for the section
exports.sectionConfig = {
    previousSection: previousSectionName,
    nextSection: nextSectionName,
    title: {
        fr: 'Introduction aux déplacements',
        en: 'Trips introduction'
    },
    widgets: widgetsNames_1.widgetsNames,
    onSectionEntry: function (interview, iterationContext) {
        const needUpdateHouseholdSizeValues = (0, customHelpers_1.updateHouseholdSizeFromPersonCount)(interview);
        const person = odSurveyHelper.getPerson({
            interview,
            personId: iterationContext[iterationContext.length - 1]
        });
        // Validate the journey exists
        const journeys = odSurveyHelper.getJourneysArray({ person });
        // If the person has no journeys, we need to initialize a journey for them and make it the active one
        if (journeys.length === 0) {
            const newJourneysValuesByPath = (0, helpers_1.addGroupedObjects)(interview, 1, 1, `household.persons.${person._uuid}.journeys`, 
            // Set the new person popup flag, the corresponding widget will determine if it needs to be displayed for this context
            [{ startDate: (0, helpers_1.getResponse)(interview, '_assignedDay'), _showNewPersonPopupButton: true }]);
            const newJourneyKey = Object.keys(newJourneysValuesByPath).find((key) => key.startsWith(`response.household.persons.${person._uuid}.journeys.`));
            // From the newJourneyKey, get the journey UUID as the rest of the string after the last dot
            const journeyUuid = newJourneyKey.split('.').pop();
            newJourneysValuesByPath['response._activeJourneyId'] = journeyUuid;
            return needUpdateHouseholdSizeValues
                ? (0, merge_1.default)(needUpdateHouseholdSizeValues, newJourneysValuesByPath)
                : newJourneysValuesByPath;
        }
        // If the person has journeys, we need to make sure the active journey is set
        const currentJourney = journeys[0];
        const responseToUpdate = { 'response._activeJourneyId': currentJourney._uuid };
        // Initialize the departure place type based on the first visited place activity
        const visitedPlaces = odSurveyHelper.getVisitedPlacesArray({ journey: currentJourney });
        if (visitedPlaces.length >= 1) {
            const firstVisitedPlace = visitedPlaces[0];
            const firstActivity = firstVisitedPlace.activity;
            // make sure the departurePlaceOther matches the first visited place activity (if the respondent changes it after selecting the departure place other):
            responseToUpdate[`response.household.persons.${person._uuid}.journeys.${currentJourney._uuid}.departurePlaceIsHome`] = firstActivity === 'home' ? 'yes' : 'no';
            if (firstActivity) {
                const firstActivityCategory = firstVisitedPlace.activityCategory;
                let departurePlaceOther = null;
                if (firstActivity === 'otherParentHome' || firstActivityCategory === 'otherParentHome') {
                    departurePlaceOther = 'otherParentHome';
                }
                else if (firstActivity === 'restaurant') {
                    departurePlaceOther = 'restaurant';
                }
                else if (firstActivity === 'secondaryHome') {
                    departurePlaceOther = 'secondaryHome';
                }
                else if (firstActivity === 'visiting') {
                    departurePlaceOther = 'sleptAtFriends';
                }
                else if (firstActivityCategory === 'work') {
                    departurePlaceOther = 'workedOvernight';
                }
                else if (firstActivityCategory === 'school') {
                    departurePlaceOther = 'studying';
                }
                else if (firstActivity !== 'home') {
                    departurePlaceOther = 'other';
                }
                if (departurePlaceOther !== currentJourney.departurePlaceOther) {
                    responseToUpdate[`response.household.persons.${person._uuid}.journeys.${currentJourney._uuid}.departurePlaceOther`] = departurePlaceOther;
                }
            }
        }
        return needUpdateHouseholdSizeValues
            ? (0, merge_1.default)(needUpdateHouseholdSizeValues, responseToUpdate)
            : responseToUpdate;
    },
    onSectionExit: (interview, iterationContext) => {
        // Update the person visited places if there was a change
        const person = odSurveyHelper.getPerson({
            interview,
            personId: iterationContext[iterationContext.length - 1]
        });
        // Validate the journey exists
        const journey = odSurveyHelper.getJourneysArray({ person })[0];
        if (journey === undefined) {
            // This shouldn't happen, but log anyway, just in case
            console.error('No journey found for person:', person._uuid);
            return undefined;
        }
        const personDidTrips = journey.personDidTrips;
        const personDidTripsConfirm = journey.personDidTripsConfirm;
        if (personDidTrips === 'no' && personDidTripsConfirm === 'yes') {
            // If the person did not make any trips, but then confirmed they actually did, reset the personDidTrips to yes
            return {
                [`response.household.persons.${person._uuid}.journeys.${journey._uuid}.personDidTrips`]: 'yes',
                [`response.household.persons.${person._uuid}.journeys.${journey._uuid}.personDidTripsConfirm`]: undefined
            };
        }
        else if (personDidTrips === 'no' && personDidTripsConfirm === 'no') {
            // If the person confirms they did not make any trips, we need to remove the journeys and visited places
            return {
                [`response.household.persons.${person._uuid}.journeys.${journey._uuid}.visitedPlaces`]: undefined,
                [`response.household.persons.${person._uuid}.journeys.${journey._uuid}.trips`]: undefined,
                [`response.household.persons.${person._uuid}.journeys.${journey._uuid}.personDidTripsConfirm`]: undefined
            };
        }
        return undefined;
    },
    enableConditional: function (interview) {
        const person = odSurveyHelper.getPerson({ interview });
        return (0, helper_1.householdMembersSectionComplete)(interview);
    },
    isSectionCompleted: function (interview) {
        const person = odSurveyHelper.getPerson({ interview });
        return (0, helper_1.householdMembersSectionComplete)(interview) && (0, helper_1.tripsIntroForPersonComplete)(person, interview);
    }
};
exports.default = exports.sectionConfig;
